import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { IonIcon } from '@ionic/react';
import { printOutline } from 'ionicons/icons';
import { useState } from 'react';
import { createPrintJob } from '@application/features/print/PrintNodeService';
import jsPDF from 'jspdf';
const WorkorderLabelPreview = ({ onClose, workOrder }) => {
    const [printerId, setPrinterId] = useState(undefined);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handlePrintNode = async () => {
        setIsSubmitted(true);
        try {
            const currentDate = new Date()
                .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })
                .replace(/\//g, '-')
                .replace(' ', '');
            var html = `<div style="width: 2000px; text-align: left;white-space: nowrap;">
                      <br><br>
                        <span style="font-size: 120px; line-height: 1.2;">${workOrder?.workOrderNumber ?? ''}</span><br>
                        <span style="font-size: 80px; line-height: 1.2;">${workOrder?.debtorName ?? ''}</span><br>
                        <span style="font-size: 80px; line-height: 1.2;">${currentDate}</span>
                    </div> `;
            const pdfContentBase64 = await convertHtmlToPdfBase64(html);
            const printJob = {
                title: 'Werkorder Label',
                contentType: 'pdf_base64',
                content: pdfContentBase64,
                printerId: printerId ?? 0,
                source: 'Visser App'
            };
            if (printerId && printerId > 0) {
                const response = await createPrintJob(printJob);
                if (response)
                    onClose();
                console.log('Print job created:', response);
            }
        }
        catch (error) {
            console.error('Error creating print job:', error);
        }
    };
    const convertHtmlToPdfBase64 = async (html) => {
        return new Promise((resolve, reject) => {
            const doc = new jsPDF({ unit: 'pt', format: 'a4', orientation: 'landscape' });
            doc.html(html, {
                callback: (doc) => {
                    try {
                        const base64Content = doc.output('datauristring').split(',')[1];
                        resolve(base64Content);
                    }
                    catch (error) {
                        console.error('Error converting HTML to PDF base64:', error);
                        reject(error);
                    }
                }
            });
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("br", {}), _jsx("h1", { children: workOrder?.workOrderNumber }), _jsx("h4", { children: workOrder?.debtorName }), _jsx("h4", { children: `${String(new Date().getDate()).padStart(2, '0')}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${new Date().getFullYear()}` }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsxs("label", { className: 'form-label vn-text-label', children: ["Afdrukker Id", _jsx("span", { className: 'vn-AsterikMark', children: "*" })] }), _jsx("input", { type: 'number', className: 'form-control vn-Input', value: printerId, onChange: (e) => setPrinterId(e.target.value ? parseInt(e.target.value) : undefined), placeholder: 'Voer printer-ID in', required: true })] }), isSubmitted && !printerId && _jsx("p", { className: 'vn-input-field-error', children: "Afdrukker Id is vereist" })] })] }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', type: 'button', onClick: onClose, children: "Annuleren" }), _jsxs(VnButton, { type: 'button', onClick: handlePrintNode, customClassName: 'Vn-save-button vn-popup-save-button vn-quotation-preview-print-button', mode: 'primary', children: [_jsx(IonIcon, { icon: printOutline, className: 'vn-Quotation-Preview-Button-Icon' }), "Afdrukken"] })] }) })] }));
};
export default WorkorderLabelPreview;
